import request from '@/utils/request'

/**
 * Acknowledgment pipeline board API
 * GET /acknowledgment-pipeline
 * GET /projects/{projectId}/acknowledgment-pipeline
 *
 * Mutations stay on surveyor / giser / geodesia acknowledgment endpoints.
 */

const toFlag = value => {
  if (value === true || value === 1 || value === '1') return 1
  if (value === false || value === 0 || value === '0') return 0
  return undefined
}

export const getAcknowledgmentPipeline = (params = {}) => {
  const query = {}

  if (params.current_step) query.current_step = params.current_step
  if (params.step_status) query.step_status = params.step_status
  if (params.actor_user_id) query.actor_user_id = params.actor_user_id
  if (params.keyword) query.keyword = params.keyword
  if (params.include) query.include = params.include
  if (params.page) query.page = params.page
  if (params.per_page || params.perPage) {
    query.per_page = params.per_page || params.perPage
  }
  if (params.actors_limit || params.actorsLimit) {
    query.actors_limit = params.actors_limit || params.actorsLimit
  }

  const mine = toFlag(params.mine)
  if (mine !== undefined) query.mine = mine

  const hasChat = toFlag(params.has_chat)
  if (hasChat !== undefined) query.has_chat = hasChat

  if (!query.include) {
    query.include = 'actors,chat,history,center'
  }

  return request({
    url: '/acknowledgment-pipeline',
    method: 'get',
    params: query,
  })
}

export const getProjectAcknowledgmentPipeline = projectId => request({
  url: `/projects/${projectId}/acknowledgment-pipeline`,
  method: 'get',
})
